export enum UsersMutationTypes {
  ADD_USER = "ADD_USER",
  UPDATE_USER = "UPDATE_USER",
  SET_USERS = "SET_USERS",
  SET_AUTH_FRIENDS = "SET_AUTH_FRIENDS",
  SET_PHONE_CONTACTS = "SET_PHONE_CONTACTS",
  SET_PHONE_CONTACTS_USERS = "SET_PHONE_CONTACTS_USERS",
}
